import ButtonML from '@/components/button_ml/ButtonML';
import styles from './action.less?modules';
import { useTrigger } from '@/utils/comHook.js';
import ModalML from '@/components/modal_ml/ModalML';
import ModalConfirmML from '@/components/modal_ml/modal_confirm_ml/ModalConfirmML';
import { useContext } from 'react';
import { FunctionContext } from '../../index';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { message } from 'antd';
import EditModal from '@/containers/edit_modal/EditModal';
import { toOption } from '@/utils/comUtil.js';
import { fieldType } from '@/constants.js';
import { useDispatch, useSelector } from 'dva';
const formList = [
  {
    name: 'fieldName',
    type: 'input',
    label: '临时变量名称',
    required: true,
  },
  {
    name: 'variableName',
    type: 'input',
    label: '变量名',
    required: true,
  },
  {
    name: 'fieldType',
    type: 'select',
    label: '字段类型',
    required: true,
    option: toOption(fieldType),
  },
  {
    name: 'defaultValue',
    type: 'input',
    label: '默认值',
    required: true,
  },
  {
    name: 'exceptionValue',
    type: 'input',
    label: '异常值',
    required: true,
  },
  {
    name: 'description',
    type: 'input',
    label: '字段描述',
    required: true,
  },
  // {
  //   name: 'fieldStatus',
  //   type: 'select',
  //   label: '状态',
  //   required: true,
  //   option: toOption(fieldPackageStatus),
  // },
];
const baseInfo = {
  variableType: 'TEMPORARY',
};
const Action = (props) => {
  const trigger = useTrigger();
  const trigger2 = useTrigger();
  const { singleListInfo } = props;
  const dispatch = useDispatch();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['tvf/editField'];
  const { fetchData } = useContext(FunctionContext);
  const deleteField = (id) => {
    dispatch({
      type: 'tvf/deleteField',
      payload: {
        id,
      },
      callback: (d) => {
        if (d?.code) {
          message.error(d.message);
        } else {
          message.success('删除成功');
        }
        fetchData();
        trigger2.close();
      },
    });
  };
  const handleDelete = () => {
    deleteField(singleListInfo.id);
  };
  const editSingleField = (value, id) => {
    dispatch({
      type: 'tvf/editField',
      payload: {
        values: {
          ...value,
          ...baseInfo,
        },
        id,
      },
      callback: () => {
        message.success('编辑成功');
        fetchData();
        trigger.close();
      },
    });
  };
  return (
    <div className={styles.handle_btn}>
      <ButtonML
        size="large"
        value="编辑"
        onClick={trigger.open}
        disabled={String(singleListInfo?.editable) === 'false'}
      />
      <ModalConfirmML
        title="是否确认删除?"
        handleOk={handleDelete}
        handleCancel={trigger2.close}
        visible={trigger2.visible}
        value="删除"
        icon={<ExclamationCircleOutlined />}
        disabled={String(singleListInfo?.editable) === 'false'}
      />
      <ModalML
        title="编辑"
        handleOk={trigger.open}
        handleCancel={trigger.close}
        visible={trigger.visible}
      >
        <EditModal
          singleListInfo={singleListInfo}
          handleCancel={trigger.close}
          formList={formList}
          loading={loading}
          edit={editSingleField}
        />
      </ModalML>
    </div>
  );
};
export default Action;
